<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="促销名">
                <el-input v-model="formInline.promotionName" placeholder="促销名"></el-input>
            </el-form-item>

            <el-form-item label="开始日期">
                <el-date-picker
                        v-model=formInline.beginTime
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
                <el-date-picker
                        v-model=formInline.endTime
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formInline.status" clearable placeholder="状态">
                    <el-option v-for="item in searchStatusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <!--                <el-button type="success" @click="handleAdd">弹窗新增</el-button>-->
                <el-button type="success" @click="handleEditNew({promotionId:0})">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="promotionListData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="促销信息" width="300">
                <template slot-scope="scope">
                    <div class="product-container">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="product-image">
                                    <img :src="scope.row.picUrl" width="80" height="80"  alt="商品图片">
                                </div>
                            </el-col>
                            <el-col :span="16" >
                                <div class="product-info">
                                    <el-row> <h4>{{scope.row.promotionName}}</h4></el-row>
                                    <el-row>促销类型:{{getPromotionType(scope.row.promotionType)}}</el-row>
                                    <el-row>ID:{{scope.row.promotionId}}</el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column prop="promotionName" label="促销名称"></el-table-column>-->
            <el-table-column prop="" label="商品信息" width="180">
                <template slot-scope="scope">
                    <span>{{scope.row.productDesc}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="unit" label="售卖单位" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.unit || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="价格">
                <template slot-scope="scope">
                    <p>原价:{{scope.row.originPrice}}</p>
                    <p>促销价:{{scope.row.promotionPrice}}</p>
                    <p>{{scope.row.isFreeFreight=="1"?"包邮":"不包邮"}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="beginTime" label="有效期">
                <template slot-scope="scope">
                    <p>有效期:</p>
                    <p>{{formatDate(scope.row.beginTime)}}</p>
                    <p>{{formatDate(scope.row.endTime)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="" label="售卖量">
                <template slot-scope="scope">
                    <p>限量数:{{scope.row.limitCount}}</p>
                    <p>剩余量:{{scope.row.balanceCount}}</p>
                </template>
            </el-table-column>
            <el-table-column label="到计时/状态">
                <template slot-scope="scope">
                    <div>
                        <div>
                            <span>{{scope.row.countdown == 0 ? '不显示' : '显示'}}</span>
                        </div>
                        <div>
                            <span>{{scope.row.status == 1 ? '已上线' : '已下线'}}</span>
                            <el-tag v-if="scope.row.status!==1" effect="plain" @click="checkOnline(scope.row)">
                                上线

                            </el-tag>
                            <el-tag v-if="scope.row.status===1" type="success" @click="checkOnline(scope.row)"
                                    effect="plain">
                                下线

                            </el-tag>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="260">
                <template slot-scope="scope">
                    <el-button-group style="margin: 5px 0">
                        <el-button type="danger" size="mini" @click="handleEditNew(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                        <el-button type="success" size="mini" @click="handleBuyRecord(scope.row)">清除购买记录</el-button>
                        <el-button type="info" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                        <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图</el-button>
                        <el-button type="primary" size="mini" v-show="scope.row.status == 1"
                                   @click="sendToSiYu(scope.row)">同步私域

                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="100px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.promotionId></el-input>
                </el-form-item>
                <el-form-item label="促销名称">
                    <el-input v-model=form.promotionName clearable placeholder="促销名称"></el-input>
                </el-form-item>
                <el-form-item label="售卖单位">
                    <el-input
                            v-model="form.unit"
                            clearable
                            placeholder="请输入售卖单位(如:份、套、盒等)"
                            maxlength="20">
                    </el-input>
                </el-form-item>
                <el-form-item label="开始日期">
                    <el-date-picker
                            v-model=form.beginTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                            v-model=form.endTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="促销/预售">
                    <el-select v-model="form.flag" placeholder="促销/预售">
                        <el-option v-for="item in flagData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="促销类型">
                    <el-select v-model="form.promotionType" placeholder="促销类型">
                        <el-option v-for="item in promotionTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="限购数">
                    <el-input-number v-model="form.limitCount" :min="0" :max="100000" label="限购数"></el-input-number>
                </el-form-item>
                <el-form-item label="每日限购数">
                    <el-input-number v-model="form.userLimitCount" :min="0" :max="100000"
                                     label="用户限购数"></el-input-number>
                </el-form-item>
                <el-form-item label="虚拟销售数">
                    <el-input-number v-model="form.saled" :min="0" :max="100000" label="虚拟销售数"></el-input-number>
                </el-form-item>
                <el-form-item label="促销活动">
                    <el-select v-model="form.activeNo" clearable filterable placeholder="促销活动">
                        <el-option v-for="item in activeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="随机销售">
                    <el-select v-model="form.saleRand" placeholder="随机销售">
                        <el-option v-for="item in randData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序号">
                    <el-input-number v-model="form.sequence" :min="0" :max="100000" label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="是否可用优惠券">
                    <el-select v-model="form.useCoupon" placeholder="是否可用优惠券">
                        <el-option v-for="item in cacheticketStatusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="配置产品" :visible.sync="dialogProductVisible" center>
            <el-form :model="formProduct" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=formProduct.promotionId></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="formProduct.productType" clearable placeholder="商品类型" @change="handleChange">
                        <el-option v-for="item in productTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="促销商品">
                    <el-select v-model="formProduct.productId" filterable clearable @change="handleItemChange">
                        <el-option v-for="item in itemData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原价">
                    <el-input v-model="formProduct.originPrice" clearable placeholder="原价" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="促销价">
                    <el-input v-model="formProduct.promotionPrice" clearable placeholder="促销价"></el-input>
                </el-form-item>
                <el-form-item label="每单限购数">
                    <el-input-number v-model="formProduct.limitCount" :min="1" :max="100000"
                                     label="每日限购数"></el-input-number>
                </el-form-item>
                <el-form-item label="排序号">
                    <el-input-number v-model="formProduct.sequence" :min="1" :max="1000" label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示">
                    <el-select v-model="formProduct.isshow" placeholder="是否显示">
                        <el-option v-for="item in showData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否VIP">
                    <el-select v-model="formProduct.isvip" placeholder="是否VIP">
                        <el-option v-for="item in isVipData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联VIP权益">
                    <el-select v-model="formProduct.vipRightType" placeholder="关联VIP权益">
                        <el-option v-for="item in vipRightTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogProductVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveProduct(formProduct)">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
        <el-dialog title="配送设置" :visible.sync="dialogModuleVisible" center>
            <el-button type="warning" @click="handleDeliverAdd">新增</el-button>
            <el-table :data="configListData" stripe border center v-loading="loading">
                <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="cityNames" label="城市"></el-table-column>
                <el-table-column prop="deliverDate" label="配送日期" width="260">
                    <template slot-scope="scope">
                        <el-date-picker
                                v-model=scope.row.deliverDate
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期">
                        </el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="countdown" label="到计时" sortable width="120">
                    <template slot-scope="scope">
                        <el-switch
                                v-model="scope.row.countdown"
                                :active-value="1"
                                :inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" sortable width="240">
                    <template slot-scope="scope">
                        <!--<el-select v-model="scope.row.status"  placeholder="状态">-->
                        <!--<el-option v-for="item in statusData"-->
                        <!--:key="item.id"-->
                        <!--:label="item.name"-->
                        <!--:value="item.id">-->
                        <!--</el-option>-->
                        <!--</el-select>-->
                        <el-switch
                                v-model="scope.row.status"
                                :active-value="1"
                                :inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleDeliverCity(scope.row)">更改城市</el-button>
                        <el-button type="warning" size="mini" @click="handleDeliverEdit(scope.row)">保存</el-button>

                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="城市选择" :visible.sync="dialogCityVisible" center>
            <el-tree :data="cityData" node-key="id" class="el-tree" :props="defaultProps" ref="tree"
                     show-checkbox></el-tree>
            <el-button type="warning" @click="handleCitySelect()">确定</el-button>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        promotionList,
        getPromotion,
        addPromotion,
        delPromotion,
        clearPromotionBuy,
        getPromotionProduct,
        addPromotionProduct,
        getItems,
        getProduct,
        getGroup,
        getProvinceCity,
        getDeliverConfig,
        saveDeliverConfig,
        getPromotionTransportType,
        saveMediatApi,
        setOnlineOrOffLine
    } from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    import Preview from "@/components/Preview";
    //import itemSelect from '@/components/item'

    //定义组件
    export default{
        data(){
            return {
                linkType: 4,
                activeType: -1,
                params: {},
                showPreviewDialog: false,
                configListData: [],
                cityData: [],
                itemData: [],
                productTypeData: [{"id": "2", "name": "套装"}, {"id": "4", "name": "单品"}],
                promotionListData: [],
                promotionTypeData: [{"id": 1, "name": "按总数"}, {"id": 2, "name": "按天数"}],
                flagData: [{"id": 1, "name": "促销"}, {"id": 2, "name": "预售"}],
                statusData: [{"id": 1, "name": "启用"}, {"id": 0, "name": "禁用"}],
                searchStatusData: [{"id": 999, "name": "全部"}, {"id": 1, "name": "启用"}, {"id": 2, "name": "禁用"}],
                activeData: [],
                randData: [{"id": 0, "name": "不随机"}, {"id": 1, "name": "随机"}],
                cacheticketStatusData: [{"id": 0, "name": "否"}, {"id": 1, "name": "是"}],
                showData: [{"id": 0, "name": "否"}, {"id": 1, "name": "是"}],
                isVipData: [{"id": 0, "name": "否"}, {"id": 1, "name": "是"}],
                loading: true,
                dialogFormVisible: false,
                dialogProductVisible: false,
                dialogModuleVisible: false,
                form: {
                    "promotionId": "",
                    "promotionName": "",
                    "unit": "",
                    "beginTime": "",
                    "endTime": "",
                    "promotionType": 1,
                    "limitCount": 100,
                    "userLimitCount": 0,
                    "saled": 0,
                    "status": 1,
                    "activeNo": "",
                    "sequence": 0,
                    "useCoupon": 0,
                    "saleRand": 0,
                    "flag": 1,
                    "isshow": 1
                },
                mediaEntity: {
                    type: 1,
                    itemId: '',
                    mediaType: 3
                },
                formInline: {
                    promotionId: this.$route.query.promotionId || '',
                    promotionName: this.$route.query.promotionName || "",
                    beginTime: "",
                    endTime: "",
                    status: 999,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formProduct: {
                    promotionId: "",
                    productType: 2,
                    productId: "",
                    originPrice: "",
                    promotionPrice: "",
                    limitCount: "",
                    sequence: "",
                    isshow: 1,
                    isvip: 0,
                    vipRightType: ""
                },
                vipRightTypeData: [{"id": "0", "name": "请选择"}, {"id": "2", "name": "会员专属套装折扣"},
                    {"id": "3", "name": "新品尝鲜权益"},
                    {"id": "4", "name": "秒杀"},
                    {"id": "12", "name": "秒杀预约"},
                    {"id": "5", "name": "提前秒杀"},
                    {"id": "6", "name": "5元私人定制礼品"},
                    {"id": "7", "name": "免费私人定制礼品"},
                    {"id": "8", "name": "LV4专属赠品"},
                    {"id": "9", "name": "LV5专属赠品"},
                    {"id": "10", "name": "Foodie Pass商城"},
                    {"id": "11", "name": "门店随时9折"},
                ],
                promotionId: "",
                dialogCityVisible: false,
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                currentCityRow: {},
            }
        },
        components: {
            selectPicComponents,
            Preview
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods: {
            //定义查询方法
            handleItemChange(data){
                console.log(this.formProduct.productType);
                if (this.formProduct.productType == "4") {
                    getProduct({proId: data}).then((res1) => {
                        this.formProduct.originPrice = res1.data.value.proPrice;
                    });
                }
                if (this.formProduct.productType == "2") {
                    getGroup({groupId: data}).then((res1) => {
                        this.formProduct.originPrice = res1.data.value.salePrice;
                    });
                }
            },
            handleChange(data){
                getItems({itemType: data}).then((res1) => {
                    this.itemData = res1.data;
                    this.formProduct.productId = "";
                });
            },
            getList(){
                promotionList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.promotionListData = res.data.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            checkOnline(row){
                setOnlineOrOffLine({promotionId: row.promotionId}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDel(row){
                if (confirm("确定删除促销:" + row.promotionName + "吗？")) {
                    delPromotion({promotionId: row.promotionId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }
            },
            handlePic(row){
                if (row.promotionProductId == '') {
                    this.$message({
                        showClose: true,
                        message: '请先选择产品~',
                        type: 'error'
                    });
                } else {
                    let routerL = '/' + this.$route.path.split('/')[1];
                    this.$router.push({
                        path: routerL + '/picture/' + row.promotionProductId,
                        query: {picType: '10', picName: row.promotionName, picState: 'promotion'}
                    })
                }
            },
            handleAdd(){
                this.dialogFormVisible = true;
                getPromotion({promotionId: ""}).then((res) => {
                    this.activeData = res.data.value.activeData;
                });
            },
            sendToSiYu(row){
                this.mediaEntity.itemId = row.promotionId
                saveMediatApi(this.mediaEntity).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        //this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleEditNew(data){
                this.$router.push({
                    path: '/promotionlist/detail/:id',
                    name: 'PromotionDetail',
                    params: {id: data.promotionId},
                    query: {promotionId: data.promotionId, picType: '10', picFrom: 'noReturn'}
                })
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                //得到实体
                getPromotion({promotionId: data.promotionId}).then((res) => {
                    console.log(res);
                    this.activeData = res.data.value.activeData;
                    this.form = res.data.value;
                    //this.items=res.data.value.items;
                });
            },
            save(data){
                if (data.promotionName == "") {
                    this.$message({
                        message: "请输入促销名称",
                        type: 'error'
                    });
                    return;
                }
                if (data.beginTime == "") {
                    this.$message({
                        message: "请选择开始时间",
                        type: 'error'
                    });
                    return;
                }
                if (data.endTime == "") {
                    this.$message({
                        message: "请选择结束时间",
                        type: 'error'
                    });
                    return;
                }
                if (data.limitCount === "") {
                    this.$message({
                        message: "请输入用户限购数量",
                        type: 'error'
                    });
                    return;
                }
                if (data.saled === "") {
                    this.$message({
                        message: "请输入虚拟销售数",
                        type: 'error'
                    });
                    return;
                }
                if (data.sequence === "") {
                    this.$message({
                        message: "请输入排序号",
                        type: 'error'
                    });
                    return;
                }
                delete data["activeData"];
                console.log(data);
                addPromotion(data).then((res) => {
                    //console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage, this.pageSize);
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveProduct(data){
                if (data.promotionId == "") {
                    this.$message({
                        message: "请选择商品类型",
                        type: 'error'
                    });
                    return;
                }
                if (data.productType == "") {
                    this.$message({
                        message: "请选择商品类型",
                        type: 'error'
                    });
                    return;
                }
                if (data.productId == "") {
                    this.$message({
                        message: "请选择商品",
                        type: 'error'
                    });
                    return;
                }
                if (data.promotionPrice == "") {
                    this.$message({
                        message: "请输入销售价",
                        type: 'error'
                    });
                    return;
                }
                if (data.limitCount == "") {
                    this.$message({
                        message: "请输入限购数",
                        type: 'error'
                    });
                    return;
                }
                if (data.sequence == "") {
                    this.$message({
                        message: "请输入排序号",
                        type: 'error'
                    });
                    return;
                }
                addPromotionProduct(data).then((res) => {
                    //console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.dialogProductVisible = false;
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleBuyRecord(data){
                //得到实体
                clearPromotionBuy({promotionId: data.promotionId}).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            handleProduct(data){
                this.dialogProductVisible = true;
                //得到实体
                this.formProduct.promotionId = data.promotionId;
                getPromotionProduct({promotionId: data.promotionId}).then((res) => {
                    if (res.data.value != "") {
                        getItems({itemType: res.data.value.productType}).then((res1) => {
                            this.itemData = res1.data;
                            this.formProduct = res.data.value;
                        });
                    } else {
                        var promotionId = this.formProduct.promotionId;
                        for (let key in this.formProduct) {
                            this.formProduct[key] = ''
                        }
                        this.formProduct.promotionId = promotionId;
                    }
                    //this.items=res.data.value.items;
                });
            },
            handleModule(data){
                this.dialogModuleVisible = true;
                this.promotionId = data.promotionId;
                getDeliverConfig({"promotionId": data.promotionId}).then((res1) => {
                    this.configListData = res1.data.value;
                });
            },
            saleRandVisible(row, column, cellValue) {
                for (var key in this.randData) {
                    if (this.randData[key].id == cellValue) {
                        return this.randData[key].name;
                    }
                }
                //return this.randData.name;

            },
            statusVisible(row, column, cellValue) {
                for (var key in this.statusData) {
                    if (this.statusData[key].id == cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;
            },
            promotionTypeVisible(row, column, cellValue) {
                for (var key in this.promotionTypeData) {
                    if (this.promotionTypeData[key].id == cellValue) {
                        return this.promotionTypeData[key].name;
                    }
                }
                //return this.randData.name;
            },
            getPromotionType(cellValue) {
                for (var key in this.promotionTypeData) {
                    if (this.promotionTypeData[key].id == cellValue) {
                        return this.promotionTypeData[key].name;
                    }
                }
                return ''
            },
            dateTimeFormatter(row, column, cellValue){
                return cellValue;//(new Date(cellValue).format("yyyy-MM-dd HH:mm:ss"));
            },
            handleDeliverAdd(){
                this.configListData.push({
                    "buyId": this.promotionId,
                    "cityIds": "",
                    "cityNames": "",
                    "configClassId": "",
                    "configDetailId": "",
                    "configTimesId": 0,
                    "deliverDate": null,
                    "status": 1
                });
            },
            handleDeliverEdit(data){
                saveDeliverConfig(data).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.dialogProductVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleDeliverCity(data){
                this.dialogCityVisible = true;
                this.currentCityRow = data;
                getPromotionTransportType(this.promotionId).then((res) => {
                    var transportType = 1;
                    if (res.data.value != null) {
                        transportType = res.data.value;
                    }
                    getProvinceCity({"transportType": transportType}).then((res1) => {
                        this.cityData = res1.data;
                    });
                });
            },
            handleCitySelect(){

                var nodes = this.$refs.tree.getCheckedNodes();
                var ids = [];
                var names = [];
                for (var i in nodes) {
                    console.log(nodes[i]);
                    if (nodes[i].leaf == 1) {
                        ids.push(nodes[i].id);
                        names.push(nodes[i].name);
                    }
                }
                this.currentCityRow.cityIds = ids.join(",");
                this.currentCityRow.cityNames = names.join(",");
                this.dialogCityVisible = false;
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            handlePreActive(row){
                //this.activeType=row.activeType;
                this.params = {productId: row.promotionId, productType: 1};
                this.showPreviewDialog = true;
            }

        }
    }
    Date.prototype.format = function (format) {
        var o = {
            "M+": this.getMonth() + 1, //month
            "d+": this.getDate(), //day
            "HH+": this.getHours(), //hour
            "m+": this.getMinutes(), //minute
            "s+": this.getSeconds(), //second
            "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
            "S": this.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)if (new RegExp("(" + k + ")").test(format))
            format = format.replace(RegExp.$1,
                RegExp.$1.length == 1 ? o[k] :
                    ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    }
</script>
<style>
    .product-image {
        flex: 1; /* 图片占用可用空间的1份 */
        background-repeat: no-repeat; /* 确保图片不会重复 */
        background-size: cover; /* 图片自适应容器大小 */
        min-width: 0; /* 防止图片因响应式布局而扭曲 */
    }

    .product-info {
        flex: 2; /* 商品信息占用可用空间的2份 */
        padding-left: 20px; /* 为商品信息添加左边距 */
    }

    /* 兼容性问题处理 */
    /* Internet Explorer 10 */
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .product-container {
            display: -ms-flexbox;
        }
    }

    /* Internet Explorer 11 */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast:none) {
        .product-image {
            flex: 1 0 auto;
        }
        .product-info {
            flex: 2 0 auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/promotion/promotionList.vue